module.exports = __webpack_public_path__ + "static/media/20201129_192253_062_IMG_1731.b860f02c.jpg";